/**
 * The overlay stacking order — one source for the z-index of the shared overlay
 * primitives. A popover or a select can be opened from inside a dialog (the agent
 * workspace ⋯ menu in the Quick Agents dialog), so both sit ABOVE the dialog layer;
 * a select can be opened from inside a popover, so it sits above that; a tooltip can
 * hover over any of them, so it is the top layer.
 */
export const Z_LAYERS = {
  dialog: 20000,
  popover: 21000,
  select: 21100,
  tooltip: 21200,
} as const;
